import { c as _c } from "react/compiler-runtime";
import { LockClosedIcon } from '@heroicons/react/24/solid';
import type { ARTICLE_STATE } from '@/app/baza/(collection)/_utils/ArticleStateContext/types';
import type { StructureArticleDTO } from '@/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto';
import { DOCS__PERMISSIONS } from '@/backend/modules/docs/permissions';
import { DOCS_READING_STATUS_DESCRIPTIONS } from '@/common/enums';
import { Caption } from '@/frontend/design-system/typography/Caption';
import { useAuth } from '@/frontend/hooks/useAuth';
import { cn } from '@/frontend/utils';
import { ArticleStatusIcon } from './ArticleStatusIcon';
import { ArticleTitle } from './ArticleTitle';
type ArticleButtonProps = {
  article: StructureArticleDTO;
  canManageCollection: boolean;
  isCurrent: boolean;
  status?: ARTICLE_STATE;
  onClick: () => void;
};
export function ArticleButton(t0) {
  const $ = _c(33);
  const {
    article,
    canManageCollection,
    isCurrent,
    status,
    onClick
  } = t0;
  const {
    user
  } = useAuth();
  let t1;
  if ($[0] !== canManageCollection || $[1] !== user) {
    t1 = canManageCollection && user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ASSIGNED]) || user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ALL]);
    $[0] = canManageCollection;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canManageArticle = t1;
  const isLoggedIn = Boolean(user.id);
  let t2;
  if ($[3] !== canManageArticle || $[4] !== isCurrent || $[5] !== isLoggedIn || $[6] !== status) {
    t2 = (canManageArticle || isLoggedIn) && <ArticleStatusIcon status={status} isCurrent={isCurrent} />;
    $[3] = canManageArticle;
    $[4] = isCurrent;
    $[5] = isLoggedIn;
    $[6] = status;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== article || $[9] !== isCurrent) {
    t3 = <ArticleTitle article={article} isCurrent={isCurrent} />;
    $[8] = article;
    $[9] = isCurrent;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== article.hasPublishedVersion || $[12] !== canManageArticle || $[13] !== status) {
    t4 = canManageArticle && <div className="flex flex-col gap-y-0.5"><Caption className={cn(article.hasPublishedVersion ? "text-contentGreen" : "text-contentTertiary")}>{article.hasPublishedVersion ? "Opublikowany" : "Nieopublikowany"}</Caption>{status != null && <Caption className="text-contentTertiary">{DOCS_READING_STATUS_DESCRIPTIONS[status]}</Caption>}</div>;
    $[11] = article.hasPublishedVersion;
    $[12] = canManageArticle;
    $[13] = status;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== canManageArticle || $[16] !== isLoggedIn || $[17] !== status) {
    t5 = !canManageArticle && isLoggedIn && status && <Caption className="text-contentTertiary">{DOCS_READING_STATUS_DESCRIPTIONS[status]}</Caption>;
    $[15] = canManageArticle;
    $[16] = isLoggedIn;
    $[17] = status;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <div className="flex flex-col gap-y-1 text-left">{t3}{t4}{t5}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t2 || $[24] !== t6) {
    t7 = <div className="flex items-start gap-3">{t2}{t6}</div>;
    $[23] = t2;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== article.isProtected || $[27] !== isLoggedIn) {
    t8 = article.isProtected && !isLoggedIn && <LockClosedIcon className="h-5 w-5 shrink-0 text-contentTertiary" />;
    $[26] = article.isProtected;
    $[27] = isLoggedIn;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== onClick || $[30] !== t7 || $[31] !== t8) {
    t9 = <button type="button" className="flex cursor-default items-center justify-between gap-2 rounded-lg p-2 hover:bg-backgroundHoverOverlay" onClick={onClick}>{t7}{t8}</button>;
    $[29] = onClick;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}